/**
 * Enhances variant stock accessibility without touching theme.js
 */
(() => {
  const onReady = (cb) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', cb);
    } else {
      cb();
    }
  };

  const parseJSON = (element) => {
    if (!element) return null;
    try {
      return JSON.parse(element.textContent);
    } catch (error) {
      console.warn('inventory-accessibility: failed to parse JSON', error);
      return null;
    }
  };

  const normalizeRemaining = (value) => {
    if (value === null || typeof value === 'undefined') return null;
    if (typeof value === 'number') return value;

    const trimmedValue = String(value).trim();
    if (trimmedValue === '') return null;

    const numericValue = Number(trimmedValue);
    if (!Number.isNaN(numericValue)) {
      return numericValue;
    }
    return trimmedValue;
  };

  const buildStatusText = (strings, remaining, variant) => {
    if (!strings) return '';
    const normalized = normalizeRemaining(remaining);

    if (normalized === 'out' || normalized === 0 || variant?.available === false) {
      return strings.out || strings.unavailable || '';
    }

    if (normalized === 'in' || normalized === null) {
      return variant?.available === false ? strings.out || strings.unavailable || '' : strings.in || strings.low || '';
    }

    if (normalized === 'low') {
      return strings.low || strings.lowWithCount || strings.in || '';
    }

    if (typeof normalized === 'number') {
      if (normalized <= 0) {
        return strings.out || strings.unavailable || '';
      }
      if (strings.lowWithCount) {
        return strings.lowWithCount.replace('__COUNT__', normalized);
      }
      return strings.low || strings.in || '';
    }

    return strings.unavailable || '';
  };

  const updateListItems = (items, variantId, text) => {
    items.forEach((item) => {
      const matches = Number(item.getAttribute('data-variant-id')) === variantId;
      if (matches) {
        item.setAttribute('data-selected', 'true');
        const statusNode = item.querySelector('[data-variant-stock-status]');
        if (statusNode) statusNode.textContent = text;
      } else {
        item.removeAttribute('data-selected');
      }
    });
  };

  onReady(() => {
    const productComponents = document.querySelectorAll('product-component');
    if (!productComponents.length) return;

    productComponents.forEach((component) => {
      if (component.dataset.stockAccessibilityInit === 'true') return;

      const stockList = component.querySelector('[data-variant-stock-list]');
      const productJSONEl = component.querySelector('[data-product-json]');

      if (!stockList || !productJSONEl) return;

      const productData = parseJSON(productJSONEl);
      if (!productData) return;

      component.dataset.stockAccessibilityInit = 'true';

      const statusEl = component.querySelector('[data-variant-accessibility-status]');
      const variantSelect = component.querySelector('[data-product-select]');
      const remainingJSONEl = component.querySelector('[data-product-remaining-json]');

      let remainingData = parseJSON(remainingJSONEl);
      const stockItems = Array.from(stockList.querySelectorAll('[data-variant-stock]'));
      const strings = {
        in: stockList.dataset.stockTextIn || '',
        out: stockList.dataset.stockTextOut || '',
        low: stockList.dataset.stockTextLow || '',
        lowWithCount: stockList.dataset.stockTextLowWithCount || '',
        unavailable: stockList.dataset.stockTextUnavailable || '',
      };

      const getRemainingForVariant = (variantId) => {
        if (!remainingData) return null;
        const key = String(variantId);
        return typeof remainingData[key] !== 'undefined' ? remainingData[key] : null;
      };

      const applyStatus = (variant) => {
        if (!variant) {
          if (statusEl) statusEl.textContent = strings.unavailable;
          stockItems.forEach((item) => item.removeAttribute('data-selected'));
          return;
        }

        const remainingValue = getRemainingForVariant(variant.id);
        const statusText = buildStatusText(strings, remainingValue, variant);

        updateListItems(stockItems, variant.id, statusText);

        if (statusEl) {
          const label = variant.public_title || variant.title || productData.title || '';
          statusEl.textContent = label ? `${label}: ${statusText}` : statusText;
        }
      };

      const resolveVariantById = (variantId) => {
        if (!variantId || !productData.variants) return null;
        const numericId = Number(variantId);
        return productData.variants.find((variant) => Number(variant.id) === numericId) || null;
      };

      const handleVariantChange = (variant) => {
        if (!variant) return;
        applyStatus(variant);
      };

      component.addEventListener('theme:variant:change', (event) => {
        const variantFromEvent = event.detail?.variant || null;
        handleVariantChange(variantFromEvent);
      });

      const initialVariant = variantSelect ? resolveVariantById(variantSelect.value) : productData.variants?.[0];
      applyStatus(initialVariant);

      if (remainingJSONEl) {
        const observer = new MutationObserver(() => {
          remainingData = parseJSON(remainingJSONEl) || remainingData;
        });
        observer.observe(remainingJSONEl, {characterData: true, subtree: true});
      }
    });
  });
})();

